import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { notifications as mantineNotifications } from "@coveord/plasma-mantine";
import { IconAlertSquareFilled, IconAlertTriangleFilled, IconCircleCheckFilled } from "@coveord/plasma-react-icons";
import { NotificationTracking } from "../tracking/NotificationTracking.js";
var errorRegistry = new Set();
var showErrorNotification = function(notification, error) {
    var notificationProps;
    if (typeof notification === "string") {
        notificationProps = {
            id: notification,
            message: notification,
            icon: /*#__PURE__*/ _jsx(IconAlertSquareFilled, {
                size: 20,
                color: "var(--mantine-color-red-4)"
            }),
            autoClose: false,
            onClose: function(props) {
                errorRegistry.delete(props.id);
            },
            "data-variant": "error"
        };
    } else {
        notificationProps = _object_spread_props(_object_spread({}, notification), {
            icon: /*#__PURE__*/ _jsx(IconAlertSquareFilled, {
                size: 20,
                color: "var(--mantine-color-red-4)"
            }),
            autoClose: false,
            onClose: function(props) {
                var ref;
                if (props.id) {
                    errorRegistry.delete(props.id);
                }
                notification === null || notification === void 0 ? void 0 : (ref = notification.onClose) === null || ref === void 0 ? void 0 : ref.call(notification, props);
            },
            "data-variant": "error"
        });
    }
    // prevents from showing the same error notification twice when it can easily be uniquely distinguished
    if (!notificationProps.id || !errorRegistry.has(notificationProps.id)) {
        if (notificationProps.id) {
            errorRegistry.add(notificationProps.id);
        }
        mantineNotifications.show(notificationProps);
        NotificationTracking.errorShown(_object_spread({}, notificationProps, error));
    }
};
var showSuccessNotification = function(notification) {
    if (typeof notification === "string") {
        mantineNotifications.show({
            message: notification,
            icon: /*#__PURE__*/ _jsx(IconCircleCheckFilled, {
                height: 20,
                color: "var(--mantine-color-green-2)"
            }),
            "data-variant": "success"
        });
    } else {
        mantineNotifications.show(_object_spread_props(_object_spread({}, notification), {
            icon: /*#__PURE__*/ _jsx(IconCircleCheckFilled, {
                height: 20,
                color: "var(--mantine-color-green-2)"
            }),
            "data-variant": "success"
        }));
    }
};
var showWarningNotification = function(notification) {
    if (typeof notification === "string") {
        mantineNotifications.show({
            message: notification,
            icon: /*#__PURE__*/ _jsx(IconAlertTriangleFilled, {
                height: 20,
                color: "var(--mantine-color-yellow-3)"
            }),
            "data-variant": "warning"
        });
    } else {
        mantineNotifications.show(_object_spread_props(_object_spread({}, notification), {
            icon: /*#__PURE__*/ _jsx(IconAlertTriangleFilled, {
                height: 20,
                color: "var(--mantine-color-yellow-3)"
            }),
            "data-variant": "warning"
        }));
    }
};
var cleanNotifications = function() {
    errorRegistry.clear();
    mantineNotifications.clean();
};
var cleanQueueNotifications = function() {
    errorRegistry.clear();
    mantineNotifications.cleanQueue();
};
export var notifications = _object_spread_props(_object_spread({}, mantineNotifications), {
    /**
     * Removes all notifications from the notifications state, queue and errorRegistry
     * @example ```ts
     * notifications.clean();
     * ```
     */ clean: cleanNotifications,
    /**
     * Removes all notifications from the queue and errorRegistry
     * @example ```ts
     * notifications.cleanQueue();
     * ```
     */ cleanQueue: cleanQueueNotifications,
    /**
     * Shows an error notification
     *
     * @param notification The error notification to display
     * @example ```ts
     * notifications.showError('Unexpected error');
     * notifications.showError({title: 'Unexpected error', message: 'Description of the error'});
     *
     * // when using an object, its best to set an id to avoid spamming the same error notification more than once
     * notifications.showError({id: 'error-xyz', title: 'Unexpected error', message: 'Description of the error'});
     * ```
     */ showError: showErrorNotification,
    /**
     * Shows a success notification
     *
     * @param notification The success notification to display
     * @example ```ts
     * notifications.showSuccess('Successfully saved');
     * notifications.showSuccess({title: 'Success!', message: 'The resource was successfully saved.'});
     * ```
     */ showSuccess: showSuccessNotification,
    /**
     * Shows a warning notification
     *
     * @param notification The warning notification to display
     * @example ```ts
     * notifications.showWarning('Watch out!');
     * notifications.showWarning({title: 'Watch out!', message: 'Your config might be wrong.'});
     * ```
     */ showWarning: showWarningNotification
});

//# sourceMappingURL=notifications.js.map